import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import axios from 'axios'

import { MultipleCheckbox, SimpleButton } from '../CommonComponents'
import { swalError, swalNotify } from '../../common/components/Swaler'
import { niceDate } from '../../common/utils'

const fullCol = { xs: 12, md: 12, lg: 12 }

const QToolsDeliveriesSection = ({ deliveries, mutateSmss }) => {
  const defaultText = `Hej, Uppdatera gärna adressen på dina beställningar${deliveries[0].vendorName ? ` från ${deliveries[0].vendorName}` : ''} till "${
    deliveries[0].lockStreet
  }" så hamnar de i leveranscontainern. Då slipper du även bli avbruten och gå ner och möta transportören. Mvh Qlocx`

  const [receivers, setReceivers] = useState(null)
  const [text, setText] = useState(defaultText)

  const uniqueReceiversArray = []
  for (const delivery of deliveries) {
    if (!delivery.to_customer || (!delivery.to_customer.phone && !delivery.identifiedPhone)) continue

    if (!uniqueReceiversArray.some((d) => d.to_customer._id === delivery.to_customer._id)) {
      uniqueReceiversArray.push(delivery)
      continue
    }

    if (!uniqueReceiversArray.some((d) => d.identifiedPhone === delivery.identifiedPhone)) uniqueReceiversArray.push({ identifiedPhone: delivery.identifiedPhone, to_customer: { _id: delivery.identifiedPhone, phone: delivery.identifiedPhone } })
  }

  const save = () => {
    if (!receivers.length) {
      swalError('Du måste välja mottagare')
      return
    }

    const newSmss = []

    const phones = receivers.map((r) => {
      newSmss.push({
        _id: `${r.value}${text}`,
        recipient: r.value,
        body: text,
        messageCreated: text,
      })
      return r.value
    })

    axios.post(`${window.MYQLOCX_API}/subject/admin/qtools/smses`, { text, phones, deliveryIds: deliveries.map((d) => d._id) }).then(() => {
      swalNotify('SMS skapade')
      mutateSmss((prev) => newSmss.concat(prev))
    })
  }

  const createCustomerLabel = (d) => {
    let label
    if (d.to_customer && d.to_customer.name) {
      label = `${d.to_customer.name} ${d.to_customer.surname} (${d.to_customer.phone})`
    } else if (d.to_customer && d.to_customer.phone && !d.to_customer.name) {
      label = `Inbjuden (${d.to_customer.phone})`
    } else {
      label = `Ej registrerad (${d.identifiedPhone})`
    }

    if (d.notifications && d.notifications.length) label += ` - notifierad ${niceDate(d.notifications[d.notifications.length - 1].date)}`

    return label
  }

  const driverNames = deliveries.reduce((acc, d) => {
    if (d.driverAliases) {
      const name = `${d.driverName} (${d.driverAliases.join(', ')})`
      acc.add(name)
    }

    return acc
  }, new Set())

  return (
    <Grid>
      {driverNames.size > 0 && (
        <Row className="qSection">
          <Col {...fullCol}>
            <h3>{`Chaufför: ${driverNames.join(', ')}`}</h3>
          </Col>
        </Row>
      )}
      <Row className="qSection">
        <Col {...fullCol}>
          <h3>Skicka ut SMS till grindleverans-mottagare</h3>
        </Col>
        <Col {...fullCol}>
          <textarea style={{ width: '100%', height: 100 }} value={text} onChange={(e) => setText(e.target.value)} />
        </Col>
        <Col {...fullCol}>
          <MultipleCheckbox reportChange={(values) => setReceivers(values)} options={uniqueReceiversArray.filter((f) => !!f).map((d) => ({ label: createCustomerLabel(d), value: d.to_customer.phone || d.identifiedPhone }))} />
        </Col>
        <Col {...fullCol}>
          <SimpleButton onClick={save} text="Skicka" />
        </Col>
      </Row>
    </Grid>
  )
}

export default QToolsDeliveriesSection
